export default "__VITE_ASSET__DPHfzqAT__"